import { render, staticRenderFns } from "./OpenBankingSuccess.vue?vue&type=template&id=caf09ab4&"
import script from "./OpenBankingSuccess.vue?vue&type=script&lang=ts&"
export * from "./OpenBankingSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports